import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';

import './CompatWarningDialog.css'

function CompatWarningDialog() {
    return (
        <Dialog onClose={() => {}} open={true} sx={{
            '& .MuiPaper-root': {
                padding: '20px',
                color: 'white',
                backgroundColor: '#1d2027'
            },
        }}>
            <DialogTitle sx={{
                textAlign: 'center',
                padding: '5px 24px'
            }}>Graphics Acceleration required!</DialogTitle>
            <p>This web app uses WebGPU for 3D rendering. Please enable graphics acceleration and reload the page. If you still see this message, <a href='https://caniuse.com/webgpu'>check your browser for WebGPU compatibiliy.</a></p>
        </Dialog>
    )
};
export default CompatWarningDialog;